import { createContext, useContext } from 'react'
import { type DataExplorerParamsState } from './dataExplorerParams.types'

export const DataExplorerParamsContext = createContext<DataExplorerParamsState>(undefined)
export const useDataExplorerParamsContext = () => useContext(DataExplorerParamsContext)
